var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-download",attrs:{"href":_vm.downloadLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }